import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";

export const sendForm = createAsyncThunk(
  "prospects/form",
  async (prospect, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        "https://harmastudio-dev-69b634b453a9.herokuapp.com/api/prospects/",
        prospect
      );
      return response.data;
    } catch (error) {
      return rejectWithValue({
        message:
          error.response?.data?.message || "Error al enviar el formulario",
        status: error.response?.status || 500,
      });
    }
  }
);

///prospect/vote  vote: vote;1,2,3,4
//*  propsects/votes, get, []
//* prospects/votes/count , get 1

// @desc   Fetch prospects
// @route  GET /api/prospects
// @access Private
// @query  keyword, pageNumber, pageSize, sort, order
export const getProspects = createAsyncThunk(
  "api/prospects",
  async (params, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        "https://harmastudio-dev-69b634b453a9.herokuapp.com/api/admin/prospects",
        { params }
      ); // ?keyword=${keyword}&pageNumber=${pageNumber}&pageSize=${pageSize}&sort=${sort}&order=${order}
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Failed to fetch prospect"
      );
    }
  }
);

export const editStatusPropsect = createAsyncThunk(
  "prospect/editStatus",
  async ({ id, status }, { rejectWithValue }) => {
    try {
      const response = await axios.put(
        `https://harmastudio-dev-69b634b453a9.herokuapp.com/api/admin/prospect/${id}/status`,
        { status }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Error al editar el status"
      );
    }
  }
);

export const editProspects = createAsyncThunk(
  "prospect/edit",
  async ({ id, prospect }, { rejectWithValue }) => {
    try {
      const response = await axios.put(
        `https://harmastudio-dev-69b634b453a9.herokuapp.com/api/admin/prospect/${id}`,
        { prospect }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Error al editar el prospecto"
      );
    }
  }
);

export const deleteProspect = createAsyncThunk(
  "prospect/delete",
  async (id, { rejectWithValue }) => {
    try {
      const response = await axios.delete(
        `https://harmastudio-dev-69b634b453a9.herokuapp.com/api/admin/prospect/${id}`
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Error al eliminar el prospecto"
      );
    }
  }
);

const initialState = {
  formData: {},
  loading: false,
  error: null,
  prospects: [],
  prospects_copy: [],
  numProspectos: localStorage.getItem("numProspectos")
    ? parseInt(localStorage.getItem("numProspectos"), 10)
    : 8,
};

const userSlice = createSlice({
  name: "formulario",
  initialState,
  reducers: {
    setNumProspectos: (state, action) => {
      state.numProspectos = action.payload;
      localStorage.setItem("numProspectos", action.payload);
    },
    sortProspects: (state, action) => {
      const order = action.payload;
      if (state.prospects && Array.isArray(state.prospects)) {
        if (order === "asc" || order === "desc") {
          state.prospects.sort((a, b) => {
            const nameA = a.name.toLowerCase();
            const nameB = b.name.toLowerCase();

            if (order === "asc") {
              return nameA.localeCompare(nameB);
            } else if (order === "desc") {
              return nameB.localeCompare(nameA);
            }
            return 0;
          });
        } else if (order === "") {
          state.prospects = [...state.prospects_copy];
        }
      }
    },
    sortNewIdea: (state, action) => {
      const order = action.payload;
      if (state.prospects) {
        if (order === true || order === false) {
          state.prospects.sort((a, b) => {
            const newIdeaA = a.newIdea;
            const newIdeaB = b.newIdea;

            if (order === true) {
              return newIdeaA === newIdeaB ? 0 : newIdeaA ? -1 : 1;
            } else if (order === false) {
              return newIdeaA === newIdeaB ? 0 : newIdeaB ? -1 : 1;
            }
            return 0;
          });
        } else if (order === null) {
          state.prospects = [...state.prospects_copy];
        }
      }
    },
    filterByStatus: (state, action) => {
      const status = action.payload;
      if (state.prospects_copy) {
        if (status) {
          state.prospects = state.prospects_copy.filter(
            (prospect) => prospect.status === status
          );
        } else {
          state.prospects = [...state.prospects_copy];
        }
      }
    },
    sortByNamePodcast: (state, action) => {
      const order = action.payload;
      if (state.prospects) {
        if (order === "asc" || order === "desc") {
          state.prospects.sort((a, b) => {
            const nameA = a.namePodcast.toLowerCase();
            const nameB = b.namePodcast.toLowerCase();

            if (order === "asc") {
              return nameA.localeCompare(nameB);
            } else if (order === "desc") {
              return nameB.localeCompare(nameA);
            }
            return 0;
          });
        } else if (order === "") {
          state.prospects = [...state.prospects_copy];
        }
      }
    },
    sortByStatus: (state, action) => {
      const status = action.payload;
      if (state.prospects) {
        if (status === "asc" || status === "desc") {
          state.prospects.sort((a, b) => {
            const nameA = a.status.toLowerCase();
            const nameB = b.status.toLowerCase();

            if (status === "asc") {
              return nameA.localeCompare(nameB);
            } else if (status === "desc") {
              return nameB.localeCompare(nameA);
            }
            return 0;
          });
        } else if (status === "") {
          state.prospects = [...state.prospects_copy];
        }
      }
    },
    filterByNewIdea: (state, action) => {
      const idea = action.payload;
      if (state.prospects_copy) {
        if (idea === true) {
          state.prospects = state.prospects_copy.filter(
            (prospect) => prospect.newIdea === true
          );
        } else if (idea === false) {
          state.prospects = state.prospects_copy.filter(
            (prospect) => prospect.newIdea === false
          );
        } else {
          state.prospects = [...state.prospects_copy];
        }
      }
    },
    filterByName: (state, action) => {
      const name = action.payload;
      if (name) {
        state.prospects = state.prospects_copy.filter((prospect) =>
          prospect.name.toLowerCase().includes(name.toLowerCase())
        );
      } else {
        state.prospects = [...state.prospects_copy];
      }
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(sendForm.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(sendForm.fulfilled, (state, action) => {
        state.loading = false;
        state.formData = action.payload;
      })
      .addCase(sendForm.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(getProspects.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getProspects.fulfilled, (state, action) => {
        state.loading = false;
        state.prospects = action.payload;
        state.prospects_copy = [...action.payload];
      })
      .addCase(getProspects.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(editStatusPropsect.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(editStatusPropsect.fulfilled, (state, action) => {
        state.loading = false;
        if (state.prospects) {
          state.prospects = state.prospects.map((prospect) =>
            prospect.id === action.payload.prospect._id
              ? action.payload.prospect
              : prospect
          );
        }
        if (state.prospects_copy) {
          state.prospects_copy = state.prospects_copy.map((prospect) =>
            prospect.id === action.payload.prospect._id
              ? action.payload.prospect
              : prospect
          );
        }
      })
      .addCase(editStatusPropsect.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(editProspects.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(editProspects.fulfilled, (state, action) => {
        state.loading = false;
        if (state.prospects) {
          state.prospects = state.prospects.map((prospect) =>
            prospect._id === action.payload._id ? action.payload : prospect
          );
        }
        if (state.prospects_copy) {
          state.prospects_copy = state.prospects_copy.map((prospect) =>
            prospect._id === action.payload._id ? action.payload : prospect
          );
        }
      })
      .addCase(editProspects.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(deleteProspect.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteProspect.fulfilled, (state, action) => {
        state.loading = false;
        if (state.prospects) {
          state.prospects = state.prospects.filter((prospect) =>
            prospect._id !== action.payload._id ? action.payload : prospect
          );
        }

        if (state.prospects_copy) {
          state.prospects_copy = state.prospects_copy.filter((prospect) =>
            prospect._id !== action.payload._id ? action.payload : prospect
          );
        }
      });
  },
});

export const {
  sortProspects,
  filterByStatus,
  filterByNewIdea,
  filterByName,
  sortByStatus,
  sortNewIdea,
  setNumProspectos,
} = userSlice.actions;
export default userSlice.reducer;
